// extracted by mini-css-extract-plugin
module.exports = {"spinContainer":"tableContext_spinContainer__1-les"};